module.exports = __webpack_public_path__ + "static/media/Giztix.57394055.jpg";